module.exports = "<md-content ng-if=!vm.noContent class=md-padding><md-backdrop ng-if=vm.submitting class=md-opaque></md-backdrop><ng-transclude layout=column></ng-transclude></md-content><gz-spinner ng-if=vm.submitting class=gz-spinner-container></gz-spinner>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/form-content/form-content.jade
// module id = 239
// module chunks = 0